<template>
  <div class="limited-access-card">
    <NoticeCard
      title="Поиск ограничен"
      :image="$options.limitedImage"
      appearance="no-content-new"
    >
      <template #description>
        <template v-if="limitedAccess.type === 'hasCompany'">
          При <a href="/info/help_hr#q2.11">размещении вакансии</a>
          вы&nbsp;получаете одни сутки доступа к&nbsp;базе резюме&nbsp;—&nbsp;30
          открытий контактов (активируются в момент публикации вакансии).
          В&nbsp;случае размещения нескольких вакансий время доступа и
          количество открытий контактов суммируется. Вы&nbsp;всегда можете
          приобрести доступ к&nbsp;базе резюме в&nbsp;качестве
          <a target="_blank" href="/info/help_hr#q2.12">отдельной услуги</a>.
        </template>
        <template v-else-if="limitedAccess.type === 'noCompany'">
          Полный поиск по&nbsp;базе соискателей доступен кураторам компаний
          <a href="/info/help_hr#q2.11">с&nbsp;размещёнными вакансиями</a>
          или оплаченным <a href="/info/help_hr#q2.12">доступом к&nbsp;базе</a>.
          Услуги сервиса можно приобрести только из&nbsp;кабинета компании,
          регистрация компаний бесплатна.
        </template>
        <template v-else-if="limitedAccess.type === 'guest'">
          Полный поиск по&nbsp;базе специалистов доступен только
          зарегистрированным пользователям с&nbsp;созданным профилем компании,
          у&nbsp;которых есть
          <a href="/info/help_hr#q2.11">размещённая вакансия</a>
          или приобретён
          <a href="/info/help_hr#q2.12">доступ к&nbsp;базе резюме</a>.
        </template>
      </template>

      <template #actions>
        <template v-if="limitedAccess.type === 'hasCompany'">
          <BasicButton
            :href="limitedAccess.addVacancyHref"
            appearance="secondary"
            size="m"
            rel="nofollow"
            @click="onCreateVacancyClick"
          >
            Разместить вакансию
          </BasicButton>
          <BasicButton
            :href="limitedAccess.buyAccessHref"
            appearance="primary"
            size="m"
            rel="nofollow"
            @click="onPurchaseAccessClick"
          >
            Купить доступ
          </BasicButton>
        </template>
        <template v-else-if="limitedAccess.type === 'noCompany'">
          <BasicButton
            :href="limitedAccess.newCompanyHref"
            appearance="primary"
            size="m"
            rel="nofollow"
            @click="onCreateCompanyClick"
          >
            Создать компанию
          </BasicButton>
        </template>
        <template v-else-if="limitedAccess.type === 'guest'">
          <BasicButton
            :href="limitedAccess.loginHref"
            appearance="primary"
            size="m"
            rel="nofollow"
            @click="onLoginClick"
          >
            Войти
          </BasicButton>
          <BasicButton
            :href="limitedAccess.registerHref"
            appearance="primary"
            size="m"
            rel="nofollow"
            @click="onRegisterClick"
          >
            Зарегистрироваться
          </BasicButton>
        </template>
      </template>
    </NoticeCard>
  </div>
</template>

<script>
import BasicButton from 'src/components/BasicButton/BasicButton.vue';
import NoticeCard from 'src/components/NoticeCard/NoticeCard.vue';

import limitedImage from 'images/no_content.icon.response.png';

export default {
  name: 'LimitedAccessCard',
  components: { BasicButton, NoticeCard },
  limitedImage: {
    src: limitedImage,
    width: 96,
    height: 96,
  },
  props: {
    limitedAccess: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onCreateVacancyClick() {
      window.helpers.trackEvent('resumeblock', 'vacancy_create');
    },
    onPurchaseAccessClick() {
      window.helpers.trackEvent('resumeblock', 'buy_access');
    },
    onCreateCompanyClick() {
      window.helpers.trackEvent('resumeblock', 'company_create');
    },
    onLoginClick() {
      window.helpers.trackEvent('resumeblock', 'sign_in');
    },
    onRegisterClick() {
      window.helpers.trackEvent('resumeblock', 'sign_up');
    },
  },
};
</script>
